import React from 'react';

import { Box } from '../../../../../Box';
import { Typography } from '../../../../../Typography';
import { Icon } from '../../../../../Icon';
import { useHeight } from '../hooks';

interface VideoFailedProps {
  height?: string | number;
  width?: string | number;
}

export const VideoFailed = ({ height, width }: VideoFailedProps) => {
  const defaultHeight = useHeight();

  return (
    <Box
      bgcolor="bg.greyscale.primary"
      height={height || defaultHeight}
      width={width || '100%'}
      maxWidth="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="8"
      radius="s"
    >
      <Icon
        name="error_circle_fill_gray"
        size="20"
        color="text.light.tertirary"
      />
      <Typography variant="subtitle1" color="text.light.primary">
        Не удалось загрузить видео
      </Typography>
    </Box>
  );
};
